import(/* webpackMode: "eager" */ "/workspace/pkgs/apps/a-htz/src/app/(fullPage)/(postMain)/article/labels/[id]/error.tsx");
